<template>
  <div :id="componentId">
    <div v-if="productData.HeadingTitle" class="row">
      <h1 class="before-after-augmented-heading">{{ productData.HeadingTitle }}</h1>
    </div>
    <div class="row before-after-augmented-container">
      <div
        v-for="(product, index) in productData.BeforeAfterComparisonSlide"
        :key="index"
        class="col-xs-12 col-sm-6 col-md-4"
      >
        <div class="before-after-augmented-wrapper-content">
          <h2 v-if="product.Title" class="before-after-augmented-title">{{ product.Title }}</h2>
          <span v-if="product.Description" class="before-after-augmented-description">{{
            product.Description
          }}</span>
          <before-after-augmented
            v-if="product.BeforeImage.Src && product.AfterImage.Src"
            :before-label="product.BeforeText"
            :after-label="product.AfterText"
            :carosel-color="productData.CursorHexCode"
          >
            <template #after="afterProps">
              <img
                width="500"
                :style="afterProps.dimensions"
                class="lazyload"
                :data-src="product.AfterImage.Src"
                alt="after"
                @@load="afterProps.onresize"
              />
            </template>
            <template #before="beforeProps">
              <img
                width="500"
                :style="beforeProps.dimensions"
                class="lazyload"
                :data-src="product.BeforeImage.Src"
                alt="before"
                @@load="beforeProps.onresize"
              />
            </template>
          </before-after-augmented>
        </div>
      </div>
    </div>
    <div v-if="productData.Text" class="row">
      <span class="before-after-augmented-last-line-text">{{ productData.Text }}</span>
    </div>
    <div v-if="productData.Description" class="row">
      <div
        class="before-after-augmented-description-details"
        v-html="productData.Description"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'before-after-block-augmented',
  props: {
    productData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      componentId: 'before-after-block-augmented',
    };
  },
  mounted() {
    document.addEventListener('scroll', this.menuHighlight);
  },
  methods: {
    menuHighlight() {
      const componentBlock = document.getElementById(this.componentId);
      if (componentBlock) {
        const checkOffset = componentBlock.offsetTop - 120;
        if (window.pageYOffset >= checkOffset) {
          window.eventBus.$emit('summary-menu-highlight', this.componentId);
        }
      }
    },
  },
};
</script>
